module.exports = __webpack_public_path__ + "static/media/Azonix.cdfe47b3.otf";